import '../../../../monitoring/social_contents/social_content_attachments_view.js.coffee'
Namespace 'Customer.Dashboard'

class Customer.Dashboard.TicketSummaryAttachmentsView extends
Monitoring.Views.SocialContents.SocialContentAttachmentsView

  render: ->
    super()
    @$el.addClass('summary-text')
    @
